class PredictiveSearch extends SearchForm {
  constructor() {
    super();

    this.cachedResults = {};
    this.searchTerm = '';
    this.abortController = null;

    this.predictiveSearch = document.querySelector('.predictive-search__results-groups-wrapper');
    this.listProductUlElem = this.predictiveSearch.querySelector('ul.predictive-search__list-results');
    this.headerGroup = document.querySelector('sticky-header .header-group');

    this.btnViewAll = this.predictiveSearch.querySelector('.search-submit-view-all');

    this.searchTerms = this.predictiveSearch.querySelector('#search-header-terms');
    this.btnSearchClose = this.predictiveSearch.querySelector('.btn-search-clean');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.addEventListener(
      'input',
      debounce((event) => {
        if (this.abortController) {
          this.abortController.abort();
        }

        this.abortController = new AbortController();

        this.onChange(event);
      }, 300).bind(this)
    );

    this.btnViewAll.addEventListener('click', () => {
      this.input.form.submit();
    });

    this.btnSearchClose.addEventListener('click', () => {
      this.input.value = '';

      this.closeContainerResults();
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    this.searchTerm = newSearchTerm;

    if (this.searchTerm.length <= 3) {
      if (!this.searchTerm.length) {
        this.closeContainerResults();
      }

      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  getSearchResults(searchTerm) {
    this.predictiveSearch.classList.add('loading');

    this.searchTerms.textContent = searchTerm;

    const queryKey = searchTerm.replace(' ', '-').toLowerCase();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    const query = encodeURIComponent(searchTerm);

    // const urlFetch = `${routes.predictive_search_url}.json?q=${query}&resources[type]=product&resources[options][unavailable_products]=hide`;
    const urlFetch = `${routes.predictive_search_url}.json?q=${query}&resources[type]=product&resources[options]`;

    fetch(urlFetch, {
      signal: this.abortController.signal,
    }).then((response) => {
      if (!response.ok) {
        throw new Error(response.status);
      }

      return response.json();
    }).then((data) => {
      this.cachedResults[queryKey] = data;

      this.renderSearchResults(data);
    }).catch((error) => {
      if (error.name === 'AbortError') return;

      this.closeContainerResults();

      console.error(error);

      this.predictiveSearch.classList.remove('loading');
    });
  }

  renderSearchResults(dataResponse) {
    const productsFiltered = dataResponse.resources.results.products.filter(product => !product.tags.includes('brinde'));
    const products = productsFiltered;

    if (!products.length) {
      this.predictiveSearch.classList.add('search-empty');
    } else {
      this.predictiveSearch.classList.remove('search-empty');
    }

    this.listProductUlElem.innerHTML = '';

    products.forEach(product => {
      const liHTML = this.createProductCard(product);

      this.listProductUlElem.insertAdjacentHTML('beforeend', liHTML);
    });

    const headerHeight = this.headerGroup.getBoundingClientRect().height;
    this.predictiveSearch.style.setProperty('--header-height-current', `${headerHeight}px`);

    this.predictiveSearch.classList.add('active');
    document.body.classList.add('menu-drawer-open');
    document.body.classList.add('search-header-visible');

    this.predictiveSearch.classList.remove('loading');
  }

  createProductCard(product) {
    const compareAtPrice = parseFloat(product.compare_at_price_max);
    const price = parseFloat(product.price_max);

    const discount = compareAtPrice > price ?
      Math.round((1 - price / compareAtPrice) * 100) :
      null;

    const available = product.available;
    const bestSeller = product.tags.includes('best-sellers');

    return `
      <li class="grid__item">
        <div class="product-card-wrapper">
          <div class="card card--standard">
            <div class="card__media">
              <a href="${product.url}" class="media">
                <img
                  src="${product.featured_image.url}"
                  alt="${product.featured_image.alt}"
                  class="img"
                  loading="lazy"
                  width="${product.featured_image.width}"
                  height="${product.featured_image.height}"
                />
              </a>

              <div class="group-labels">
                ${bestSeller ? '<span class="label best-sellers">Mais vendidos</span>' : ''}
                ${discount ? `<span class="label percent-off">${discount}% OFF</span>` : ''}
              </div>
            </div>

            <div class="card__content">
              <h3 class="card__heading">
                ${product.title}
              </h3>

              <div class="card__price-rating">
                <div class="price__product-card">
                  ${discount ?
                    `<s class="price__was price">${formatPriceWithCurrency(compareAtPrice)}</s>` :
                    ''
                  }

                  <span class="price__current price">
                    ${formatPriceWithCurrency(price)}
                  </span>
                </div>

                <div class="wrapper__trustvox">
                  <div
                    data-trustvox-product-code="1014"
                    data-trustvox-should-skip-filter="true"
                    data-trustvox-display-rate-schema="true"
                  ></div>
                </div>
              </div>

              <a href="${product.url}" class="link-to-product ${!available ? 'disabled' : ''}">
                ${!available ?
                  '<span>Em breve</span>' :
                  `
                    <div class="group-add-to-cart">
                      <span class="svg-wrapper">
                        <svg width="17" height="16"><use xlink:href="#icon-cart"></use></svg>
                      </span>
                      <span class="mobile-only">Comprar</span>
                      <span class="desktop-only">Adicionar ao carrinho</span>
                    </div>
                  `
                }
              </a>
            </div>
          </div>
        </div>
      </li>
    `;
  }

  closeContainerResults() {
    document.body.classList.remove('menu-drawer-open');
    document.body.classList.remove('search-header-visible');
    this.predictiveSearch.classList.remove('active');
    this.predictiveSearch.classList.remove('search-empty');
    this.listProductUlElem.innerHTML = '';
  }
}

customElements.define('predictive-search', PredictiveSearch);
